<template>
    <div class="homeContainerRefuge ">
        <div class="container underLogoPhrase" style="margin-bottom: 0px;">
         <h1 class="page-title" id="top">{{ news.nom }}</h1>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-12">

                    <div class="" style="margin-bottom: 0px;">
                        <div class="container " style="margin-top: 20px;">
                         
                            <p v-html="formattedArticle" class=""></p>

                        </div>
                    </div>

                    <div class="col-lg-6" v-if="news.image">
                        <br><br>
                    
                    <div class="" style="margin-bottom: 0px;background-color: transparent;">
                        <div class="container " style="margin-top: 20px;">
                            <img class="responsive_img" :src="'https://admin.asso-refuge.fr/images/' + news.image" />
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        <br><br>

    </div>

</template>


<style>
.content{
}

.page-title{
  text-align:center;
  font-size:44px;
  font-weight:500;
  margin:10px 0 40px;
  color:#82a93c;
}

.section-title--accent{ color:#82a93c; text-transform:uppercase; }

.text-accent{ color:#82a93c; font-weight:700; margin:18px 0 30px; }


.section-title{
font-size:30px;
font-weight:700;
margin-bottom:25px;
}

.text{
font-size:16px;
line-height:1.8;
margin-bottom:18px;
}

.text-important{
font-size:18px;
font-weight:600;
text-align:center;
margin:25px 0;
}

.divider{
margin:40px auto;
width:80px;
border:2px solid #eee;
}

.list{
padding-left:20px;
line-height:1.9;
margin:20px 0;
}

.highlight{
font-weight:600;
}

.strong{
font-weight:700;
font-size:18px;
}

.quote{
margin-top:35px;
padding:25px;
text-align:center;
font-size:18px;
font-style:italic;
background:#f7f7f7;
border-radius:8px;
}
</style>

<script>
export default {
  data() {
    return {
      news: {}, // mieux qu'un tableau
    };
  },

  mounted() {
    this.loadNews();
  },

  watch: {
    "$route.params.id": {
      immediate: false,
      handler() {
        this.loadNews();
      },
    },
  },

  methods: {
    loadNews() {
      const idSite = this.$idSite;
      const id = this.$route.params.id;

      fetch(`https://admin.asso-refuge.fr/getPagess/${idSite}/${id}`)
        .then((response) => response.json())
        .then((data) => {
          this.news = (data && data[0]) ? data[0] : {};
        })
        .catch((error) => {
          console.error("Il y a eu un problème avec votre requête :", error.message);
          this.news = {};
        });
    },
  },

  computed: {
    formattedArticle() {
      return this.news?.article || "";
    },
  },
};
</script>
